import store from 'store';
import moment from 'moment';
import { LOCAL_STORAGE_AUTH_KEY, MENTAL_HEALTH_QUESTION_TAG_APPOINTMENT, MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT } from '../config/constants';
// eslint-disable-next-line import/no-cycle
import { postAppointmentAnonymousAPICall, postAppointmentAPICall } from '../api/appointment';
// eslint-disable-next-line import/no-cycle
import AuthGuestLoggedin from '../services/AuthGuestLoggedinService';
import AuthService from '../services/AuthService';

// eslint-disable-next-line import/prefer-default-export
export const postAppointmentAll = async (phone) => {
    let guid = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
    const authCheck = new AuthGuestLoggedin()
    const dataAppointment = {
        appointment_type: "Video",
        encounter_type: "New Patient",
        tag: store.get(MENTAL_HEALTH_QUESTION_TAG_APPOINTMENT),
        appointment_date: moment(),
        health_consern: store.get(MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT),
        status: "Pending",
    }
    if (authCheck.loggedIn()) {
        const auth = new AuthService();
        const profile = auth.getUserProfile();
        guid = profile.guid;
        const {mobile} = profile;
        dataAppointment.mobile = mobile
    } else {
        dataAppointment.mobile = phone
    }
    dataAppointment.patients_ref = guid

    let checkOk = false;
    if (authCheck.loggedIn()) {
        const { responseOk } = await postAppointmentAPICall(dataAppointment);
        if (responseOk) {
            checkOk = responseOk;
        }
    } else {
        const { responseOk } = await postAppointmentAnonymousAPICall(dataAppointment);
        if (responseOk) {
            checkOk = responseOk;
        }
    }

    return { checkOk }
}